import React, { useState } from "react";
import { Card, Button } from "react-bootstrap";
import { FiFile } from "react-icons/fi";

export default function LeadsNotification() {
  const [data, setData] = useState([
    {
      id: 1,
      name: "Lex Murphy",
      text: "requested access to UNIX",
      time: "Today at 9:42 AM",
      img: "/assets/img/users/user-35-1.jpg",
      file: "EY_review.pdf",
    },
    {
      id: 2,
      name: "Lex Murphy",
      text: "requested access to UNIX",
      time: "Today at 10:00 AM",
      img: "/assets/img/users/user-02.jpg",
    },
    {
      id: 3,
      name: "Lex Murphy",
      text: "requested access to UNIX",
      time: "Today at 10:50 AM",
      img: "/assets/img/users/user-03.jpg",
      action: true,
    },
    {
      id: 4,
      name: "Lex Murphy",
      text: "requested access to UNIX",
      time: "Today at 12:00 PM",
      img: "/assets/img/users/user-04.jpg",
    },

  ]);

  // ✅ Functional Actions
  const handleApprove = (id) => {
    alert("Approved request ID: " + id);
    setData((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, action: false, approved: true } : item
      )
    );
  };

  const handleDecline = (id) => {
    alert("Declined request ID: " + id);
    setData((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, action: false, declined: true } : item
      )
    );
  };

  return (
    <Card  className="h-100" style={styles.card}>
      {/* Header */}
      <Card.Header style={styles.header}>
        <h5 style={styles.title}>Notifications</h5>
        <Button style={styles.viewBtn}>View All</Button>
      </Card.Header>

      {/* Body */}
      <Card.Body style={{ padding: "9px 0" }}>
        {data.map((n) => (
          <div key={n.id} style={styles.row}>
            
            {/* Avatar */}
            <img src={n.img} alt="" style={styles.avatar} />

            {/* Content */}
            <div style={{ flex: 1 }}>
              <p style={styles.text}>
                <span style={styles.name}>{n.name}</span> {n.text}
              </p>

              <span style={styles.time}>{n.time}</span>

              {/* File */}
              {n.file && (
                <div style={styles.fileBox}>
                  <div style={styles.fileIcon}>
                    <FiFile size={14} />
                  </div>
                  <span style={styles.fileText}>{n.file}</span>
                </div>
              )}

              {/* Actions */}
              {n.action && (
                <div style={styles.actions}>
                  <button
                    style={styles.approveBtn}
                    onClick={() => handleApprove(n.id)}
                  >
                    Approve
                  </button>

                  <button
                    style={styles.declineBtn}
                    onClick={() => handleDecline(n.id)}
                  >
                    Decline
                  </button>
                </div>
              )}
            </div>
          </div>
        ))}
      </Card.Body>
    </Card>
  );
}

/* 🔥 INTERNAL STYLES (Pixel Perfect) */
const styles = {
  card: {
    border: "2px solid #e6e8ec",
    borderRadius: "5px",
    overflow: "hidden",
  },

  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "14px 20px",
    background: "#fff",
    borderBottom: "1px solid #eef0f3",
  },

  title: {
    fontSize: "18px",
    fontWeight: "600",
    margin: 0,
    color: "#1f2a37",
  },

  viewBtn: {
    background: "#f3f4f6",
    border: "none",
    fontSize: "13px",
    padding: "4px 14px",
    borderRadius: "6px",
    color: "#111827",
  },

  row: {
    display: "flex",
    gap: "10px",
    padding: "7px 17px",
    alignItems: "flex-start",
  },

  avatar: {
    width: "41px",
    height: "41px",
    borderRadius: "50%",
    objectFit: "cover",
  },

  text: {
    fontSize: "14.5px",
    margin: "0 0 3px",
    color: "#1f2a37",
  },

  name: {
    fontWeight: "600",
  },

  time: {
    fontSize: "13px",
    color: "#6b7280",
  },

  fileBox: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    marginTop: "6px",
  },

  fileIcon: {
    width: "26px",
    height: "26px",
    borderRadius: "6px",
    background: "#fdecec",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#e74c3c",
  },

  fileText: {
    fontSize: "13px",
    color: "#1f2a37",
  },

  actions: {
    marginTop: "10px",
    display: "flex",
    gap: "10px",
  },

  approveBtn: {
    background: "#f97316",
    color: "#fff",
    border: "none",
    padding: "5px 14px",
    borderRadius: "6px",
    fontSize: "13px",
    cursor: "pointer",
  },

  declineBtn: {
    background: "#fff",
    color: "#f97316",
    border: "1px solid #f97316",
    padding: "6px 14px",
    borderRadius: "6px",
    fontSize: "13px",
    cursor: "pointer",
  },
};